import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaqService } from '@core/services/faq.service';
import { PageName } from './page-titles.enum';

@Injectable({ providedIn: 'root' })
export class TitleService {
  private baseName: string;
  constructor(
    private title: Title,
    private faqService: FaqService
  ) {}

  public setTitleAsBaseName() {
    this.baseName = this.title.getTitle();
  }

  public setBaseName(name: string) {
    this.baseName = name;
  }

  public set(name: PageName) {
    this.title.setTitle(
      `${this.baseName} - ${name
        // ensure the right format
        .split(' ')
        .map(x => x.capitalizeFirstLetter())
        .join(' ')}`
    );
    this.faqService.setCurrentPageId(name);
  }

  public clear() {
    this.title.setTitle(this.baseName);
  }
}
